import isNil from 'lodash/isNil'
import type { CentralizedHealthScore } from 'types'
import { NoRLHealthScore } from 'types'

import {
  getComponentHealthCondition,
  getRiskScoreHealthCondition,
} from './componentHealthConditions'

export interface HealthConditionInput {
  /** Minimum remaining life value */
  minRL?: number | undefined
  /** Risk score value */
  riskScore?: number | undefined
  /** Whether there is an inspection */
  hasInspection: boolean
}

/**
 * Centralized function to calculate ComponentHealthCondition.
 * This standardizes the calculation logic used across Site View and FHP.
 *
 * Priority order:
 * 1. Risk score (already includes risk class from backend)
 * 2. Minimum remaining life
 * 3. Inspection status fallback
 */
export function calculateHealthCondition({
  minRL,
  riskScore,
  hasInspection,
}: HealthConditionInput): CentralizedHealthScore {
  if (!isNil(riskScore) && riskScore !== 0) {
    return getRiskScoreHealthCondition(riskScore)
  }

  if (!isNil(minRL)) {
    return getComponentHealthCondition(minRL)
  }

  return hasInspection
    ? NoRLHealthScore.NotEnoughData
    : NoRLHealthScore.NoInspection
}
